import {
  Stage,
  Layer,
  Image as KonvaImage,
  Text,
  Transformer
} from "react-konva";

import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle
} from "react";

const STAGE_WIDTH = 900;
const STAGE_HEIGHT = 600;

const CanvasStage = forwardRef(
({ asset, config, setConfig }, ref) => {

    const stageRef = useRef(null);

    const textRefs = useRef({});

    const transformerRef = useRef(null);

    const [selectedLayerId, setSelectedLayerId] = useState(null);

    const [image, setImage] = useState(null);

    const [imageRect, setImageRect] = useState({

        x:0,

        y:0,

        width:STAGE_WIDTH,

        height:STAGE_HEIGHT

    });

    const [originalSize,setOriginalSize]=useState({

        width:0,

        height:0

    });

    useEffect(()=>{

        if(!asset) return;
        // Reset editor every time a new template opens
setSelectedLayerId(null);

if (transformerRef.current) {
    transformerRef.current.nodes([]);
}
  const img=new window.Image();

        img.crossOrigin="anonymous";

const filename = asset.file_path.split("/").pop();

img.src = `https://api.inwallz.in/uploads/original_${filename}`;

img.onerror = () => {
    img.src = `https://api.inwallz.in${asset.file_path}`;
};
        img.onload=()=>{

            setImage(img);

            setOriginalSize({

                width:img.width,

                height:img.height

            });

            const ratio=Math.min(

                STAGE_WIDTH/img.width,

                STAGE_HEIGHT/img.height

            );

            const width=img.width*ratio;

            const height=img.height*ratio;

            setImageRect({

                width,

                height,

                x:(STAGE_WIDTH-width)/2,

                y:(STAGE_HEIGHT-height)/2

            });

        };

    },[asset]);

    useEffect(() => {

    if (!transformerRef.current) return;

    if (selectedLayerId && textRefs.current[selectedLayerId]) {

        transformerRef.current.nodes([
            textRefs.current[selectedLayerId]
        ]);

    } else {

        transformerRef.current.nodes([]);

    }

    transformerRef.current.getLayer()?.batchDraw();

}, [selectedLayerId, config.layers]);
useEffect(() => {

    const handleKey = (e) => {
        if (e.key === "Escape") {
            setSelectedLayerId(null);
        }
    };

    window.addEventListener("keydown", handleKey);

    return () =>
        window.removeEventListener("keydown", handleKey);

}, []);

    useImperativeHandle(ref, () => ({

    stage: stageRef.current,

    imageRect,

    originalWidth: originalSize.width,

    originalHeight: originalSize.height,

    deselect() {
        setSelectedLayerId(null);
    },

    select(id) {
    setSelectedLayerId(id);
}

}));

    if(!image) return null;

    return(

        <Stage

            ref={stageRef}

            width={STAGE_WIDTH}

            height={STAGE_HEIGHT}

            onMouseDown={(e)=>{

                if (
    e.target === e.target.getStage() ||
    e.target.getClassName() === "Image"
) {
    setSelectedLayerId(null);
}

            }}

        >

            <Layer>

                <KonvaImage

                    image={image}

                    x={imageRect.x}

                    y={imageRect.y}

                    width={imageRect.width}

                    height={imageRect.height}

                />

                {Array.isArray(config.layers) &&
config.layers.map(layer => (

<Text

key={layer.id}

ref={node => {
    if(node){
        textRefs.current[layer.id]=node;
    }
}}

text={layer.text}
align={layer.align || "left"}

opacity={layer.opacity ?? 1}

rotation={layer.rotation || 0}

listening={true}
x={
imageRect.x+
(imageRect.width*layer.x)/100
}

y={
imageRect.y+
(imageRect.height*layer.y)/100
}

fontFamily={layer.fontFamily || "Arial"}

fontSize={layer.fontSize || 40}

fill={layer.color || "#ffffff"}

fontStyle={`${layer.bold?"bold ":""}${layer.italic?"italic":""}`}

draggable

dragBoundFunc={(pos)=>({

x:Math.max(
imageRect.x,
Math.min(pos.x,imageRect.x+imageRect.width)
),

y:Math.max(
imageRect.y,
Math.min(pos.y,imageRect.y+imageRect.height)
)

})}

onClick={(e) => {

    e.cancelBubble = true;

    setSelectedLayerId(layer.id);

}}

onTap={(e) => {

    e.cancelBubble = true;

    setSelectedLayerId(layer.id);

}}

onTap={()=>{
setSelectedLayerId(layer.id);
}}

onDragEnd={(e)=>{

const x=((e.target.x()-imageRect.x)/imageRect.width)*100;

const y=((e.target.y()-imageRect.y)/imageRect.height)*100;

setConfig(prev=>({

...prev,

layers:prev.layers.map(l=>

l.id===layer.id
?{
...l,
x,
y
}
:l

)

}));

}}

onTransformEnd={()=>{

const node=textRefs.current[layer.id];

const scale=node.scaleX();

node.scaleX(1);

node.scaleY(1);

const x=((node.x()-imageRect.x)/imageRect.width)*100;

const y=((node.y()-imageRect.y)/imageRect.height)*100;

setConfig(prev=>({

...prev,

layers:prev.layers.map(l=>

l.id===layer.id
?{

...l,

x,

y,

fontSize:Math.max(
12,
l.fontSize*scale
)

}
:l

)

}));

}}
shadowOffsetX={
    layer.shadow?.enabled
        ? layer.shadow.offsetX || 0
        : 0
}

shadowOffsetY={
    layer.shadow?.enabled
        ? layer.shadow.offsetY || 0
        : 0
}

shadowOpacity={
    layer.shadow?.enabled
        ? layer.shadow.opacity ?? 1
        : 0
}
shadowColor={
layer.shadow?.enabled
?layer.shadow.color
:undefined
}

shadowBlur={
layer.shadow?.enabled
?layer.shadow.blur
:0
}

/>

))}

                {selectedLayerId && (

<Transformer

ref={transformerRef}

rotateEnabled={false}

enabledAnchors={[
"top-left",
"top-center",
"top-right",
"middle-left",
"middle-right",
"bottom-left",
"bottom-center",
"bottom-right"
]}
boundBoxFunc={(oldBox, newBox) => {

        if (

            newBox.width < 40 ||

            newBox.height < 20

        ) {

            return oldBox;

        }

        return newBox;

    }}
/>

)}

            </Layer>

        </Stage>

    );

});

export default CanvasStage;